import { gql } from '@apollo/client';

export const GET_OFFICER_LOGIN_STATUS = gql`
  query {
    isLoggedIn @client
  }
`;
